<template>
  <div>
    <base-modal-bottom
      :on-close="removeRsvpFromState"
      ref="modal"
      title="Excluir confirmação inteira"
    >
      <template #btn-close-icon>
        <base-icon
          style="margin: 0 auto"
          width="16"
          height="16"
          name="painel/close-icon"
        />
      </template>

      <div v-if="actionLoading && !success" class="has-text-centered">
        <base-reload
          :isReload="false"
          :dark="true"
          label="Estamos excluindo, aguarde um pouquinho..."
        />
      </div>
      <div v-else-if="!actionLoading && !success">
        <div class="c-guests-delete-rsvp has-text-centered">
          <p class="is-size-4" style="margin-bottom: 1em">
            <strong class="has-text-grey-darker">
              Você realmente deseja excluir esta confirmação?
            </strong>
          </p>

          <p style="margin-bottom: 3em">
            Todos os convidados dessa confirmação serão excluídos da sua lista
            de presença.
          </p>

          <div
            class="c-guests-delete-rsvp__buttons columns is-centered has-text-centered"
          >
            <div class="column">
              <button
                @click="deleteConfirm"
                :disabled="actionLoading"
                type="button"
                class="button is-primary is-big is-fullwidth"
              >
                Sim, desejo excluir
              </button>
            </div>
            <div class="column">
              <button
                @click="close"
                type="button"
                class="button is-outlined is-big is-fullwidth"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="c-guests-delete-rsvp has-text-centered">
          <base-icon
            style="margin: 0 auto 1em"
            width="80"
            height="80"
            class="has-text-success"
            name="painel/check-circle-icon"
          />

          <p class="is-size-4" style="margin-bottom: 2em">
            <strong class="has-text-grey-darker">
              A confirmação foi excluída da sua lista com sucesso!
            </strong>
          </p>

          <button @click="close" type="button" class="button is-primary is-big">
            Ok
          </button>
        </div>
      </div>
    </base-modal-bottom>
    <BaseModalError
      ref="errorApi"
      title="Erro ao tentar excluir a confirmação"
      icon="error-api"
      message="<strong>Estamos com problemas!</strong>"
    />
  </div>
</template>

<script>
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseModalError from '@/components/BaseModalError.vue'

import RsvpApi from '@/lib/api/Rsvp'

export default {
  props: {
    rsvp: {
      type: Object,
    },
  },

  components: {
    BaseModalBottom,
    BaseModalError,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    rsvps: {
      get() {
        return this.$store.state.rsvp.rsvps
      },

      set(payload) {
        this.$store.dispatch('setRsvps', payload)
      },
    },
  },

  data() {
    return {
      checked: false,
      success: false,
      actionLoading: false,
    }
  },

  methods: {
    open() {
      this.success = false
      this.$refs.modal.open()
    },

    close() {
      this.$refs.modal.close()
    },

    removeRsvpFromState() {
      if (this.success)
        this.rsvps = this.rsvps.filter((rsvp) => rsvp.id !== this.rsvp.id)
    },

    deleteConfirm() {
      this.actionLoading = true
      const rsvpApi = new RsvpApi(this.logonToken)
      rsvpApi
        .deleteRsvp(this.rsvp.id)
        .then(() => {
          this.success = true
        })
        .catch(() => {
          this.$refs.errorApi.open()
          this.$refs.modal.close()
        })
        .finally(() => (this.actionLoading = false))
    },
  },
}
</script>

<style lang="scss">
.c-guests-delete-rsvp {
  margin: 0 auto;
  max-width: 440px;

  &__header {
    margin-bottom: 1.5em;
  }

  &__buttons {
    margin: 1.5em auto 0;
    max-width: 480px;
    flex-direction: row-reverse;
  }
}
</style>
